import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RoundsTable = styled('table')(() => ({
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
}));

export const RoundsTableRow = styled('tr')(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.grey[50],
  },
}));

export const RoundsTableHead = styled('th')(({ theme }) => ({
  padding: '6px 8px',
  fontSize: '0.68rem',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
  textAlign: 'right',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  whiteSpace: 'nowrap',
  '&:first-of-type': {
    textAlign: 'left',
  },
}));

export const RoundsTableCell = styled('td')(({ theme }) => ({
  padding: '5px 8px',
  fontSize: '0.78rem',
  textAlign: 'right',
  color: theme.palette.text.primary,
  '&:first-of-type': {
    textAlign: 'left',
    fontWeight: 600,
  },
}));

export const DocLink = styled('a')(({ theme }) => ({
  fontSize: '0.72rem',
  color: theme.palette.primary.main,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const ShareClassRow = styled('tr')(({ theme }) => ({
  '& td': {
    padding: '2px 8px',
    fontSize: '0.71rem',
    textAlign: 'right',
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    '&:first-of-type': {
      textAlign: 'left',
      paddingLeft: theme.spacing(3),
      color: theme.palette.text.secondary,
    },
  },
}));

export const TrancheRow = styled('tr')(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  '& td': {
    padding: '3px 8px',
    fontSize: '0.72rem',
    textAlign: 'right',
    color: theme.palette.text.secondary,
    borderBottom: `1px dashed ${theme.palette.grey[200]}`,
    '&:first-of-type': {
      textAlign: 'left',
      paddingLeft: theme.spacing(3),
    },
  },
}));

export const ExpandButton = styled('button')(({ theme }) => ({
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  color: theme.palette.text.secondary,
  fontSize: '0.7rem',
  marginRight: theme.spacing(0.5),
  lineHeight: 1,
  verticalAlign: 'middle',
  '&:hover': { color: theme.palette.text.primary },
}));

export const ExtensionBadge = styled('span')(({ theme }) => ({
  display: 'inline-block',
  fontSize: '0.6rem',
  fontWeight: 700,
  lineHeight: 1,
  padding: '2px 4px',
  borderRadius: 3,
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.grey[300]}`,
  marginLeft: theme.spacing(0.5),
  verticalAlign: 'middle',
}));

export const MetaPopoverBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  maxWidth: 340,
  fontSize: '0.76rem',
}));

export const MetaRow = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(0.5),
  alignItems: 'flex-start',
}));

export const MetaLabel = styled('span')(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.secondary,
  minWidth: 110,
  flexShrink: 0,
  fontSize: '0.72rem',
}));

export const MetaValue = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '0.76rem',
  wordBreak: 'break-word',
}));

export const MetaDivider = styled('hr')(({ theme }) => ({
  border: 'none',
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  margin: theme.spacing(1, 0),
}));

export const InfoButton = styled('button')(({ theme }) => ({
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  color: theme.palette.text.disabled,
  lineHeight: 1,
  verticalAlign: 'middle',
  marginLeft: theme.spacing(0.5),
  display: 'inline-flex',
  alignItems: 'center',
  '&:hover': { color: theme.palette.primary.main },
}));

export const TabRow = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  paddingBottom: theme.spacing(0.5),
}));

interface TabButtonProps {
  active?: boolean;
}

export const TabButton = styled('button')<TabButtonProps>(({ theme, active }) => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  fontSize: '0.8rem',
  fontWeight: active ? 700 : 400,
  color: active ? theme.palette.primary.main : theme.palette.text.secondary,
  borderBottom: active ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
  marginBottom: '-1px',
  transition: 'color 0.15s, border-color 0.15s',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));
